import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const AdminFingerprintsPage = () => {
  return (
    <AdminResourceCrudPage
      title="Finding Fingerprints"
      subtitle="Cross-scan deduplication fingerprints and canonical vulnerability clusters."
      icon={FingerprintOutlinedIcon}
      endpoint="/api/admin/fingerprints/"
      allowCreate={false}
      allowEdit={false}
      allowDelete={false}
      columns={[
        { key: 'last_seen_at', label: 'Last Seen', render: (row) => new Date(row.last_seen_at).toLocaleString() },
        { key: 'title', label: 'Title' },
        { key: 'severity', label: 'Severity' },
        { key: 'tool', label: 'Tool' },
        { key: 'occurrences', label: 'Occurrences' },
        { key: 'fingerprint', label: 'Fingerprint', render: (row) => (row.fingerprint ? `${row.fingerprint.slice(0, 16)}…` : '-') },
        { key: 'canonical_scan_id', label: 'Canonical Scan' }
      ]}
    />
  );
};

export default AdminFingerprintsPage;
